import React from 'react';
import { getDeviceType } from '../../utils/device';
import { Button } from '../ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const SaveContactInstructions = ({ onRetry, onClose, isInline = false }) => {
  const device = getDeviceType();

  const getInstructions = () => {
    if (device === 'ios') {
      return (
        <>
          <h4 className="font-bold text-slate-900 mb-1">On your iPhone or iPad</h4>
          <p className="text-slate-600 text-sm">Open the contact file and choose <strong>Create New Contact</strong> or <strong>Add to Existing Contact</strong>.</p>
        </>
      );
    }
    if (device === 'android') {
      return (
        <>
          <h4 className="font-bold text-slate-900 mb-1">On your Android device</h4>
          <p className="text-slate-600 text-sm">Open the downloaded <code className="bg-slate-100 px-1 rounded">.vcf</code> file from your browser's Downloads list or notifications.</p>
        </>
      );
    }
    return (
      <>
        <h4 className="font-bold text-slate-900 mb-1">On your computer</h4>
        <p className="text-slate-600 text-sm">Open the downloaded <code className="bg-slate-100 px-1 rounded">.vcf</code> file from your browser's Downloads list to add it to your contacts.</p>
      </>
    );
  };

  const content = (
    <div className="text-center">
      <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <SafeIcon icon={FiIcons.FiDownload} className="text-2xl text-slate-600" />
      </div>
      <h3 className="text-xl font-bold text-slate-900 mb-2">Save this contact</h3>
      <p className="text-slate-500 mb-6">Your device should open or download a contact file.</p>
      
      <div className="bg-slate-50 rounded-xl p-4 text-left mb-6 border border-slate-100">
        {getInstructions()}
      </div>

      <div className="flex flex-col gap-3">
        <Button variant="secondary" onClick={onRetry} className="w-full">
          <SafeIcon icon={FiIcons.FiRefreshCw} className="mr-2" /> Download Again
        </Button>
        {onClose && (
          <Button variant="ghost" onClick={onClose} className="w-full">
            Close
          </Button>
        )}
      </div>
    </div>
  );

  if (isInline) {
    return <div className="max-w-sm mx-auto p-6 bg-white rounded-2xl shadow-sm border border-slate-200">{content}</div>;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl max-w-sm w-full p-6 shadow-2xl animate-in zoom-in-95 duration-200">
        {content}
      </div>
    </div>
  );
};